/**
 * Next admin state after learning the legacy token.
 *
 * Returns the SAME object when nothing changed. That identity is load-bearing:
 * `Admin` writes this from an effect, and React bails out of the re-render only
 * when the next state is `Object.is`-equal to the previous one. A fresh object
 * literal every run is what turned this into an infinite effect loop that
 * starved the main thread and made the sidebar unclickable.
 */
export const withLegacyToken = (prev, legacyToken) =>
  prev && prev.legacyToken === legacyToken ? prev : { ...prev, legacyToken };
